<!--vue template-->
<template>
  <!-- Your template code here -->
  <div>
    <!--form activity-->
    <el-form
      :model="searchForm"
      ref="searchForm"
      :inline="true"
      size="mini"
      label-position="right"
    >
      <el-form-item label="活动名称">
        <el-input v-model="searchForm.title" clearable></el-input>
      </el-form-item>
      <el-form-item label="活动状态">
        <el-select v-model="searchForm.status" clearable filterable>
          <el-option
            v-for="item in activityStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addActivity">新增</el-button>
      </el-form-item>
    </el-form>

    <!--table-->
    <el-table
      :data="activityList"
      border
      style="width: 100%"
      size="mini"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="活动名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="status" label="活动状态" align="center">
        <template slot-scope="scope">
          <span
            >{{
              scope.row.status | activityStatusFilter(activityStatusOptions)
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="created"
        label="创建时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="modified"
        label="更新时间"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <!--link链接-->
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleEdit(scope.row)"
            >编辑</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <!--page-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>

    <!--edit-->
    <activity-edit ref="editRef" @refreshDataList="loadPage"></activity-edit>
  </div>
</template>
<script>
import { selectParameterInfoBusiness } from "@/api/api";
import { storeActivityPage } from "@/api/store";
import ActivityEdit from "./components/activityEdit";
export default {
  name: "Activity",
  components: {
    ActivityEdit
  },
  filters: {
    cubeTypeFilter(value, cubeTypeOptions) {
      if (cubeTypeOptions && cubeTypeOptions.length > 0) {
        return cubeTypeOptions.find(item => item.paraValue == value).paraName;
      }
    },
    activityStatusFilter(value, activityStatusOptions) {
      if (activityStatusOptions && activityStatusOptions.length > 0) {
        return activityStatusOptions.find(item => item.value == value).label;
      }
    }
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // cubeTypeOptions: [],
      activityStatusOptions: [
        {
          label: "未开始",
          value: 0
        },
        {
          label: "进行中",
          value: 1
        },
        {
          label: "已结束",
          value: 2
        }
      ],
      loading: false,
      activityList: []
    };
  },
  created() {
    // this.getCubeTypeOptions();
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    // getCubeTypeOptions() {
    //   selectParameterInfoBusiness({
    //     startRows: 1,
    //     pageSize: 100,
    //     paraType: "biz_activity_cube_type"
    //   }).then(res => {
    //     if (res.data.status == 100) {
    //       this.cubeTypeOptions = res.data.results.list;
    //     }
    //   });
    // },
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      storeActivityPage(this.searchForm)
        .then(res => {
          if (res.data.status == 100) {
            this.activityList = res.data.results.list;
            this.searchForm.total = res.data.results.total;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(pageNum) {
      this.searchForm.pageNum = pageNum;
      this.loadPage();
    },
    addActivity() {
      const options = {
        cubeTypeOptions: this.cubeTypeOptions,
        activityStatusOptions: this.activityStatusOptions
      };
      this.$refs.editRef.open(undefined, options);
    },
    handleEdit(row) {
      const id = row.id;
      const options = {
        cubeTypeOptions: this.cubeTypeOptions,
        activityStatusOptions: this.activityStatusOptions
      };
      this.$refs.editRef.open(id, options);
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// index.vue?1649216e